import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDateMask]',
  standalone: true
})
export class DateMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: InputEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    let value = input.value;
    const cursorPosition = input.selectionStart || 0;

    value = value.replace(/[^\d\/]/g, '');

    const parts = value.split('/');
    if (parts.length > 3) {
      value = parts.slice(0, 3).join('/');
    }

    const numbersOnly = value.replace(/\//g, '');

    let digitsBeforeCursor = 0;
    for (let i = 0; i < cursorPosition && i < value.length; i++) {
      if (value[i] >= '0' && value[i] <= '9') {
        digitsBeforeCursor++;
      }
    }

    let formatted = '';
    let newCursorPos = 0;
    let digitsProcessed = 0;

    for (let i = 0; i < numbersOnly.length && i < 8; i++) {
      if (i === 2 || i === 4) {
        formatted += '/';
        newCursorPos++;
      }
      formatted += numbersOnly[i];
      digitsProcessed++;

      if (digitsProcessed === digitsBeforeCursor) {
        newCursorPos = formatted.length;
      }
    }

    if (input.value !== formatted) {
      input.value = formatted;
      input.setSelectionRange(newCursorPos, newCursorPos);
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;

    const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'Home', 'End', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    if (event.ctrlKey && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
      return;
    }

    if (value.length >= 10 && input.selectionStart === input.selectionEnd) {
      event.preventDefault();
      return;
    }

    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
